var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'd-flex justify-content-center p-3 w-100': _vm.type === 'original',
    'd-flex justify-content-start text-secondary': _vm.type === 'small',
    'rounded border bg-light': _vm.isBordered && _vm.type === 'original'
  }},[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }